import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TEXT_LINK, IMAGE_LINK } from 'helpers/constants';

import ButtonCustom from 'components/ButtonCustom';
import LinkEdit from 'components/LinkEdit';
import CounterBadge from 'components/CounterBadge';
import CreatedLinksChart from 'components/CreatedLinksChart';
import CreatedTextLink from 'components/CreatedTextLink';
import CreatedImageLink from 'components/CreatedImageLink';

import deleteIcon from 'images/delete-icon.svg';
import pencilIcon from 'images/pencil-icon.svg';

class CreatedLink extends Component {
  static propTypes = {
    mode: PropTypes.oneOf(['display', 'edit']),
  };
  static defaultProps = {
    mode: 'display',
  };

  linkComponents = {
    [TEXT_LINK]: CreatedTextLink,
    [IMAGE_LINK]: CreatedImageLink,
  };

  handleEdit = () => {
    this.props.onEdit(this.props.link.id);
  };

  handleDelete = () => {
    this.props.onDelete(this.props.link.id);
  };

  render() {
    const {
      link,
      account,
      mode,
      onApprove,
      onEditCancel,
      dragbleImage,
    } = this.props;
    let percentage = 0;
    if (account.total_clicks !== 0) {
      percentage = Math.round((link.link_clicks / account.total_clicks) * 100);
    }

    if (mode === 'edit') {
      return (
        <LinkEdit
          link={link}
          onApprove={onApprove}
          onEditCancel={onEditCancel}
          mode={mode}
        />
      );
    }

    const LinkComponent = this.linkComponents[link.variety];

    return (
      <div className="link-itm">
        <div className="link-itm__row" onClick={this.handleEdit}>
          {dragbleImage()}
          <div className="link-itm__inner">
            <LinkComponent link={link} />
            <div className="link-itm__col">
              <CreatedLinksChart link_stat={link.link_stat_data} />
              <div className="link-itm__statistics">
                <CounterBadge
                  text="Clicks:"
                  count={link.link_clicks}
                  percent={`${percentage}%`}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="link-itm__controls">
          <ButtonCustom
            className="btn-control btn-edit"
            type="button"
            onClick={this.handleEdit}
            buttonImg={pencilIcon}
          />
          <ButtonCustom
            className="btn-control btn-delete"
            type="button"
            onClick={this.handleDelete}
            buttonImg={deleteIcon}
          />
        </div>
      </div>
    );
  }
}

export default CreatedLink;



// WEBPACK FOOTER //
// ./src/components/CreatedLink/CreatedLink.js